(function () {
  if (window.svemobSearchReady) return;
  window.svemobSearchReady = true;
  var models = [
    'iPhone 17 Pro Max','iPhone 17 Pro','iPhone 17e','iPhone 17','iPhone Air','iPhone 16 Pro Max','iPhone 16 Pro','iPhone 16 Plus','iPhone 16e','iPhone 16','iPhone 15 Pro Max','iPhone 15 Pro','iPhone 15 Plus','iPhone 15','iPhone 14 Pro Max','iPhone 14 Pro','iPhone 14 Plus','iPhone 14','iPhone 13 Pro Max','iPhone 13 Pro','iPhone 13 mini','iPhone 13','iPhone 12 Pro Max','iPhone 12 Pro','iPhone 12 mini','iPhone 12','iPhone 11 Pro Max','iPhone 11 Pro','iPhone 11','iPhone XS Max','iPhone XS','iPhone XR','iPhone X',
    'Galaxy S26 Ultra','Galaxy S26 Plus','Galaxy S26+','Galaxy S26','Galaxy S25 Ultra','Galaxy S25 Edge','Galaxy S25 Plus','Galaxy S25+','Galaxy S25','Galaxy S24 Ultra','Galaxy S24 FE','Galaxy S24 Plus','Galaxy S24+','Galaxy S24','Galaxy S23 Ultra','Galaxy S23 FE','Galaxy S23 Plus','Galaxy S23+','Galaxy S23','Galaxy S22 Ultra','Galaxy S22 Plus','Galaxy S22+','Galaxy S22','Galaxy S21 Ultra','Galaxy S21 FE','Galaxy S21 Plus','Galaxy S21+','Galaxy S21','Galaxy S20 Ultra','Galaxy S20 FE','Galaxy S20 Plus','Galaxy S20+','Galaxy S20','Galaxy S10 Lite','Galaxy S10 Plus','Galaxy S10+','Galaxy S10e','Galaxy S10','Galaxy S9 Plus','Galaxy S9+','Galaxy S9','Galaxy S8 Plus','Galaxy S8+','Galaxy S8'
  ];
  var typeRules = [
    { re: /(?:sk[aä]rm|display|lcd|oled)/i, type: 'Skärmar' },
    { re: /batteri/i, type: 'Batterier' },
    { re: /(?:laddkontakt|laddningskontakt|charging port)/i, type: 'Laddkontakter' },
    { re: /(?:bakglas|bakstycke|baksida)/i, type: 'Bakstycken' },
    { re: /kameralins/i, type: 'Kameralinser' },
    { re: /kamera/i, type: 'Kameror' },
    { re: /(?:h[oö]gtalare|speaker)/i, type: 'Högtalare' },
    { re: /mikrofon/i, type: 'Mikrofoner' },
    { re: /(?:flexkabel|flex)/i, type: 'Flexkablar' }
  ];
  function escapeValue(value) { return String(value).replace(/"/g, '\\"'); }
  var qualityNames = ['FDX PRIME', 'FDX ELITE', 'FDX ULTRA', 'FDX PRO', 'FDX LITE', 'Service Pack', 'Refurbished', 'Pulled A', 'OEM-Equivalent'];
  // Refinements are sent to Shopify, so they apply across every results page.
  function queryParts(query) {
    var expression = /^(?:tag|product_type):"[^"\\]*"(?:\s+AND\s+(?:tag|product_type):"[^"\\]*")*$/i;
    return expression.test(query) ? query.split(/\s+AND\s+/i) : null;
  }
  function readableQuery(query) {
    var parts = queryParts(query);
    if (!parts) return query;
    return parts.map(function (part) {
      var value = part.match(/:"([^"]*)"$/)[1];
      if (value === 'Apple') return 'iPhone';
      return value.replace('OEM-Equivalent', 'OEM-kvalitet').replace('Refurbished', 'Renoverad');
    }).join(' ');
  }
  function rememberQuery(query, label) {
    try {
      sessionStorage.setItem('svemobSearchQuery', query);
      sessionStorage.setItem('svemobSearchLabel', label);
    } catch (error) {}
  }
  function refineQuery(form) {
    var refinements = form.querySelector('[data-svemob-query-refinements]');
    if (!refinements || refinements.hidden) return;
    var queryInput = form.querySelector('input[name="q"]');
    var typeSelect = refinements.querySelector('[data-svemob-refine-type]');
    var qualitySelect = refinements.querySelector('[data-svemob-refine-quality]');
    var source = form.dataset.svemobBaseQuery || '';
    var parts = queryParts(source);
    if (parts) {
      parts = parts.filter(function (part) {
        var type = part.match(/^product_type:"([^"]*)"$/i);
        if (type && Array.from(typeSelect.options).some(function (option) { return option.value === type[1]; })) return false;
        var match = part.match(/^tag:"([^"]*)"$/i);
        return !match || qualityNames.indexOf(match[1]) === -1;
      });
    } else {
      parts = source ? [source] : [];
    }
    if (typeSelect.value) parts.push('product_type:"' + escapeValue(typeSelect.value) + '"');
    if (qualitySelect.value) parts.push('tag:"' + escapeValue(qualitySelect.value) + '"');
    queryInput.value = parts.length ? parts.join(' AND ') : '*';
    rememberQuery(queryInput.value, readableQuery(queryInput.value));
  }
  function structuredQuery(value) {
    var original = String(value || '').trim();
    if (!original || /(?:tag|product_type):/i.test(original)) return original;
    var lower = original.toLowerCase();
    var model = models.find(function (candidate) { return lower.indexOf(candidate.toLowerCase()) !== -1; });
    if (/\bpixel/i.test(original)) {
      var pixelModels = ((window.SVEMOB_CATALOG || {}).Google || {models:[]}).models.slice().sort(function (a,b) { return b.name.length - a.name.length; });
      var pixel = pixelModels.find(function (candidate) {
        var name = candidate.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s*');
        return new RegExp('\\b' + name + '(?![a-z0-9]|\\s+(?:\\d|pro\\b|xl\\b|fold\\b|5g\\b))', 'i').test(original);
      });
      if (!pixel) return original;
      model = pixel.name;
    }
    if (model && /^Galaxy .* Plus$/i.test(model)) model = model.replace(/ Plus$/i, '+');
    if (!model) {
      var galaxy = original.match(/\b(?:samsung\s+)?(?:galaxy\s+)?([as]\d{1,2})(?:\s*(ultra|fe|edge|plus|\+))?/i);
      if (galaxy) model = 'Galaxy ' + galaxy[1].toUpperCase() + (galaxy[2] ? (galaxy[2] === '+' || /^plus$/i.test(galaxy[2]) ? '+' : ' ' + galaxy[2]) : '');
    }
    var type = typeRules.find(function (rule) { return rule.re.test(original); });
    var parts = [];
    if (model) parts.push('tag:"' + escapeValue(model) + '"');
    else if (/\biphone\b/i.test(original)) parts.push('tag:"Apple"');
    else if (/\b(?:samsung|galaxy)\b/i.test(original)) parts.push('tag:"Samsung"');
    if (type) parts.push('product_type:"' + escapeValue(type.type) + '"');
    if (/\bprime\b/i.test(original)) parts.push('tag:"FDX PRIME"');
    else if (/\bservice\s*pack\b/i.test(original)) parts.push('tag:"Service Pack"');
    else if (/\bultra\b/i.test(original) && !(model && /Galaxy .* Ultra$/i.test(model))) parts.push('tag:"FDX ULTRA"');
    else if (/\belite\b/i.test(original)) parts.push('tag:"FDX ELITE"');
    else if (/\bfdx\s+pro\b/i.test(original)) parts.push('tag:"FDX PRO"');
    else if (/\bfdx\s+lite\b/i.test(original)) parts.push('tag:"FDX LITE"');
    else if (/\b(?:refurbished|renoverad)\b/i.test(original)) parts.push('tag:"Refurbished"');
    else if (/\bpulled\s+a\b/i.test(original)) parts.push('tag:"Pulled A"');
    else if (/\boem[ -](?:equivalent|kvalitet)\b/i.test(original)) parts.push('tag:"OEM-Equivalent"');
    return parts.length ? parts.join(' AND ') : original;
  }
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/search"]');
    if (!form) return;
    if (form.matches('[data-svemob-filter-form]')) {
      refineQuery(form);
      return;
    }
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var friendly = input.value.trim();
    input.value = structuredQuery(friendly);
    rememberQuery(input.value, friendly);
    if (!form.querySelector('input[name="type"]')) {
      var typeInput = document.createElement('input');
      typeInput.type = 'hidden'; typeInput.name = 'type'; typeInput.value = 'product'; form.appendChild(typeInput);
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-svemob-search-sort]')) return;
    var form = event.target.closest('[data-svemob-filter-form]');
    if (form && form.requestSubmit) form.requestSubmit();
  });
  document.addEventListener('input', function (event) {
    var range = event.target.closest('[data-svemob-price-range]');
    if (!range) return;
    var min = range.querySelector('[data-svemob-price-min]');
    var max = range.querySelector('[data-svemob-price-max]');
    max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? 'Högsta priset måste vara minst lika stort som lägsta priset.' : '');
  });
  document.addEventListener('invalid', function (event) {
    var details = event.target.closest('.sv-search__filter');
    if (details) details.open = true;
  }, true);
  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-svemob-clear-refinements]');
    if (!clear) return;
    var form = clear.closest('[data-svemob-filter-form]');
    form.querySelector('[data-svemob-refine-type]').value = '';
    form.querySelector('[data-svemob-refine-quality]').value = '';
    if (form.requestSubmit) form.requestSubmit();
  });
  function initSearch(scope) {
    scope.querySelectorAll('[data-svemob-search-input]').forEach(function (input) {
      if (!/(?:tag|product_type):/i.test(input.value)) return;
      var query = input.value;
      var friendly = '';
      try { if (sessionStorage.getItem('svemobSearchQuery') === query) friendly = sessionStorage.getItem('svemobSearchLabel'); } catch (error) {}
      input.value = friendly || readableQuery(query);
    });
    var currentParams = new URLSearchParams(window.location.search);
    var contextParams = ['options[prefix]', 'options[unavailable_products]', 'preview_theme_id'];
    scope.querySelectorAll('[data-svemob-filter-form]').forEach(function (form) {
      if (form.dataset.svemobFilterReady) return;
      form.dataset.svemobFilterReady = 'true';
      contextParams.forEach(function (name) {
        if (!currentParams.has(name)) return;
        var input = Array.from(form.elements).find(function (element) { return element.name === name; });
        if (!input) {
          input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input);
        }
        input.value = currentParams.get(name);
      });
      form.addEventListener('formdata', function (event) {
        form.querySelectorAll('[data-svemob-price-min], [data-svemob-price-max]').forEach(function (input) {
          if (!input.value) event.formData.delete(input.name);
        });
      });
      var refinements = form.querySelector('[data-svemob-query-refinements]');
      if (!refinements) return;
      var query = form.querySelector('input[name="q"]').value;
      var parts = queryParts(query);
      // Leave hand-written Boolean expressions intact. Normal shop searches use simple AND clauses.
      if (!parts && /\b(?:OR|NOT)\b|[()]/.test(query)) return;
      form.dataset.svemobBaseQuery = query === '*' ? '' : query;
      var typeSelect = refinements.querySelector('[data-svemob-refine-type]');
      var qualitySelect = refinements.querySelector('[data-svemob-refine-quality]');
      (parts || []).forEach(function (part) {
        var type = part.match(/^product_type:"([^"]*)"$/i);
        var tag = part.match(/^tag:"([^"]*)"$/i);
        if (type && Array.from(typeSelect.options).some(function (option) { return option.value === type[1]; })) typeSelect.value = type[1];
        if (tag && qualityNames.indexOf(tag[1]) !== -1) qualitySelect.value = tag[1];
      });
      refinements.hidden = false;
      refinements.querySelector('[data-svemob-clear-refinements]').hidden = !typeSelect.value && !qualitySelect.value;
    });
    scope.querySelectorAll('[data-svemob-clear-filters]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      contextParams.forEach(function (name) { if (currentParams.has(name)) url.searchParams.set(name, currentParams.get(name)); });
      link.href = url.pathname + url.search;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initSearch(document); });
  else initSearch(document);
  document.addEventListener('shopify:section:load', function (event) { initSearch(event.target); });
})();
